var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27.889,
    viewBox: "0 0 23 27.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    transform: "translate(-4 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26163",
    "data-name": "Tracciato 26163",
    d: "M15.5,1A11.5,11.5,0,0,1,27,12.5a13.258,13.258,0,0,1-1.78,6.331A25.146,25.146,0,0,1,21.363,24,36.278,36.278,0,0,1,15.777,28.8a.5.5,0,0,1-.555,0A36.278,36.278,0,0,1,9.637,24,25.146,25.146,0,0,1,5.78,18.831,13.258,13.258,0,0,1,4,12.5,11.5,11.5,0,0,1,15.5,1Zm0,26.78a36.775,36.775,0,0,0,5.151-4.486C23.091,20.715,26,16.749,26,12.5a10.5,10.5,0,0,0-21,0c0,4.255,2.916,8.226,5.363,10.809A36.713,36.713,0,0,0,15.5,27.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26164",
    "data-name": "Tracciato 26164",
    d: "M17.167,10A4.167,4.167,0,1,1,13,14.167,4.171,4.171,0,0,1,17.167,10Zm0,7.333A3.167,3.167,0,1,0,14,14.167,3.17,3.17,0,0,0,17.167,17.333Z",
    transform: "translate(-1.667 -1.667)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocation);
export default __webpack_public_path__ + "static/media/map-location.de907f0ee335dcceaf0caefcfc4390fb.svg";
export { ForwardRef as ReactComponent };